export default __webpack_public_path__ + "static/17-eye-scanner-f6cf5c64f75b4f5f83e5f7018d463523.png";